<template>
  <div class="player-registration-close-page">
    <v-card
      v-if="
        this.playerRegistrationInfo.registrationStatus || this.userNotInvited
      "
      class="card"
    >
      <v-icon class="mb-3" color="red" size="40">mdi-calendar-remove</v-icon>
      <h2
        class="player-registration-close-page__title"
        v-html="renderTitle"
      ></h2>
      <span v-if="isRenderSubtitle">{{ renderSubtitle }}</span>
      <button
        class="mt-5 font-weight-medium primary--text"
        type="button"
        @click="handleRedirectionToDashboard"
      >
        Return to Dashboard.
      </button>
    </v-card>
  </div>
</template>

<script>
import { i18n } from "../../../plugins/i18n";
import { mapGetters } from "vuex";
import { ModuleTypes } from "../../../store/ModuleTypes";
import { RegistrationStatusTypes } from "../enums/RegistrationStatusTypes";
import moment from "moment-timezone";
import {
  CST_TIMEZONE,
  formatDateTimezone,
  getDateInMs,
  H_AND_MINUTES_12_HOURS_FORMAT,
  MONTH_DAY_FORMAT
} from "../../../helpers/date.utils";
import { Routes } from "@/router/Routes";

const { CLOSED, DRAFT, SCHEDULED } = RegistrationStatusTypes;

export default {
  name: "PlayerRegistrationClosePage",

  computed: {
    ...mapGetters(ModuleTypes.PLAYER_REGISTRATION, [
      "playerRegistrationInfo",
      "allEventOptionsAtCapacity",
      "userNotInvited"
    ]),

    renderTitle() {
      let textDependingOnStatus = "";
      if (this.playerRegistrationInfo.registrationStatus === CLOSED) {
        textDependingOnStatus = i18n.tc("player_registration.closed");
      } else if (
        [DRAFT, SCHEDULED].includes(
          this.playerRegistrationInfo.registrationStatus
        )
      ) {
        textDependingOnStatus = i18n.tc("player_registration.not_open");
      } else if (this.allEventOptionsAtCapacity) {
        textDependingOnStatus = "currently full";
      } else if (this.userNotInvited) {
        textDependingOnStatus = "private";
      }
      return `${i18n.tc(
        "player_registration.registration_for_this_event_is"
      )} <span class="red--text">${textDependingOnStatus}.</span>`;
    },

    isRenderSubtitle() {
      const { registrationStatus, launchedOn } = this.playerRegistrationInfo;
      return [DRAFT, SCHEDULED].includes(registrationStatus) && launchedOn;
    },

    renderSubtitle() {
      const launchedOn = this.playerRegistrationInfo.launchedOn;
      const dateInMs = getDateInMs(launchedOn);
      const currentFullDate = new Date(dateInMs);
      const formattedDate = moment(
        currentFullDate.setHours(
          currentFullDate.getHours() + currentFullDate.getTimezoneOffset() / 60
        )
      ).format(MONTH_DAY_FORMAT);

      const formattedTime = formatDateTimezone(
        launchedOn,
        CST_TIMEZONE,
        H_AND_MINUTES_12_HOURS_FORMAT
      );

      return `${i18n.tc(
        "player_registration.it_will_be_available_on"
      )} ${formattedDate} ${i18n.tc("common.at")} ${formattedTime}.`;
    }
  },
  methods: {
    handleRedirectionToDashboard() {
      this.$router.push(Routes.TODAY.path);
    }
  }
};
</script>

<style scoped>
.player-registration-close-page {
  width: 80%;
}

.card {
  width: 100%;
  text-align: center;
  margin-top: 100px;
  padding: 50px 25px;
  margin-bottom: 10px;
  border-radius: 5px;
}

.player-registration-close-page__title {
  font-size: 26px;
  font-weight: var(--font-weight-regular);
  color: var(--dark-color);
}
</style>
